<script setup>
import { computed, onMounted } from "vue";

import { usePage } from "@inertiajs/vue3";

const props = defineProps({
  page: {
    type: Object,
    required: true
  }
});

const _page = usePage();

const pageHash = computed(() => props.page?.hashid);
const track = computed(() => _page.props.track);

function initMatomo() {
  const _paq = (window._paq = window._paq || []);
  _paq.push(["trackPageView"]);
  _paq.push(["enableLinkTracking"]);
  _paq.push(["enableCrossDomainLinking"]);

  const u = import.meta.env.PROD ? "//analytics.did.kr/" : "//localhost:8090/";
  _paq.push(["setTrackerUrl", u + "matomo.php"]);
  _paq.push(["setSiteId", track.value.site_id]);
  const d = document,
    g = d.createElement("script"),
    s = d.getElementsByTagName("script")[0];
  g.async = true;
  g.src = u + "matomo.js";
  s.parentNode.insertBefore(g, s);
}

// 페이지 뷰 추적 함수
function trackPageView() {
  window._paq.push(["setCustomUrl", pageHash.value]);
  window._paq.push(["trackPageView"]);
}

// 컴포넌트가 마운트될 때 Matomo 초기화
onMounted(() => {
  if (pageHash.value) {
    initMatomo();
    trackPageView();
  }
});
</script>

<template>
  <span></span>
</template>
